import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as Chevron } from '../assets/chevron-down.svg';
import './Filter.scss';
import styles from './Filter.module.scss';

export const Collapsible = ({name, children, onChange, summ, exclude, isOpen=true, isDefaultOption=false, disabled=false, tooltipText=null}) => {
  const { t } = useTranslation();

  let content = null;

  if (isOpen && !disabled) {
    content = (
      <>
        {children}
      </>
    )
  }

  const handleClick = () => {
    if (!disabled) {
      onChange(!isOpen);
    }
  };

  return (
    <>
      <div 
        className={`${styles.wrapper} ${disabled ? styles.disabled : ''}`}
        data-tooltip-id={disabled ? `tooltip-${name.replace(/\s+/g, '-').toLowerCase()}` : undefined}
        data-tooltip-content={disabled ? tooltipText : undefined}
      >
        <div 
          className={`${styles.headerSecondary} ${disabled ? styles.disabledHeader : ''}`} 
          onClick={handleClick}
          style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
        >
          <span>
          <span className={summ > 0 || isDefaultOption ? (exclude ? styles.exclude : styles.include) : styles.headerName}>{t(name)}</span>
            {summ > 0 ? <span className={`${exclude ? styles.excludeSumm : styles.includeSumm} ${styles.summ}`}>{summ}</span> : ''}
          </span>
          <Chevron 
            className={isOpen ? 'chevron-icon open' : 'chevron-icon'}
            onClick={handleClick}
            style={{ opacity: disabled ? 0.5 : 1 }}
          />
        </div>
        {content}
      </div>
      
      {disabled && tooltipText && (
        <Tooltip
          id={`tooltip-${name.replace(/\s+/g, '-').toLowerCase()}`}
          place="left"
          style={{
            borderRadius: '4px',
            padding: '8px 12px',
            fontSize: '14px',
            maxWidth: '350px',
            textAlign: 'center',
            zIndex: 9999
          }}
        />
      )}
    </>
  )
}
